'use client';
import * as styles from './styles.css';
export { styles as modalStyles };
import _extends from '@babel/runtime/helpers/esm/extends';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { useState, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { Animator } from '@paypalcorp/pp-react-animator';
import { FocusOn } from 'react-focus-on';
import { IconButton } from '@paypalcorp/pp-react-icon-button';
import { CloseIcon } from '@paypalcorp/pp-react-icons';
import { breakpoints } from '@paypalcorp/pp-react-theme';
import { isDocumentRTL, hasWindow, uniqueId, isTouchDevice, cx } from '@paypalcorp/pp-react-utils';
import { modalStyles } from '@paypalcorp/pp-react-modal';

var _excluded$1 = ["requestClose", "onBeforeClose", "className", "isHidden", "center", "noPadding", "closeButtonLabel", "noCloseButton", "closeButtonProps", "hideTitle", "showLogo", "mobileFixedHeight", "showGripper", "title", "id", "action", "headerContents", "footerContents", "footerAlign", "children", "returnFocusToTrigger", "headerClassName", "containerClassName", "contentContainerRef", "wrapperClassName", "footerClassName", "skipFormFocus", "contentScrollTop", "onContentScroll", "showDrawer"];
var closeSheet = function () {
  return true;
};

// eslint-disable-next-line complexity
var SheetComponent = function (_ref) {
  var _window, _document$getElements;
  var requestClose = _ref.requestClose,
    _ref$onBeforeClose = _ref.onBeforeClose,
    onBeforeClose = _ref$onBeforeClose === void 0 ? closeSheet : _ref$onBeforeClose,
    className = _ref.className,
    isHidden = _ref.isHidden,
    center = _ref.center,
    noPadding = _ref.noPadding,
    _ref$closeButtonLabel = _ref.closeButtonLabel,
    closeButtonLabel = _ref$closeButtonLabel === void 0 ? 'close sheet' : _ref$closeButtonLabel,
    noCloseButton = _ref.noCloseButton,
    _ref$closeButtonProps = _ref.closeButtonProps,
    closeButtonProps = _ref$closeButtonProps === void 0 ? {} : _ref$closeButtonProps,
    hideTitle = _ref.hideTitle,
    showLogo = _ref.showLogo,
    mobileFixedHeight = _ref.mobileFixedHeight,
    _ref$showGripper = _ref.showGripper,
    showGripper = _ref$showGripper === void 0 ? false : _ref$showGripper,
    title = _ref.title,
    id = _ref.id,
    action = _ref.action,
    headerContents = _ref.headerContents,
    footerContents = _ref.footerContents,
    footerAlign = _ref.footerAlign,
    children = _ref.children,
    _ref$returnFocusToTri = _ref.returnFocusToTrigger,
    returnFocusToTrigger = _ref$returnFocusToTri === void 0 ? true : _ref$returnFocusToTri,
    headerClassName = _ref.headerClassName,
    containerClassName = _ref.containerClassName,
    contentContainerRef = _ref.contentContainerRef,
    wrapperClassName = _ref.wrapperClassName,
    footerClassName = _ref.footerClassName,
    skipFormFocus = _ref.skipFormFocus,
    _ref$contentScrollTop = _ref.contentScrollTop,
    contentScrollTop = _ref$contentScrollTop === void 0 ? 0 : _ref$contentScrollTop,
    onContentScroll = _ref.onContentScroll,
    _ref$showDrawer = _ref.showDrawer,
    showDrawer = _ref$showDrawer === void 0 ? false : _ref$showDrawer,
    rest = _objectWithoutProperties(_ref, _excluded$1);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    headerScroll = _useState2[0],
    setHeaderScroll = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    footerScroll = _useState4[0],
    setFooterScroll = _useState4[1];
  var _useState5 = useState(0.5),
    _useState6 = _slicedToArray(_useState5, 2),
    dynamicHeight = _useState6[0],
    setDynamicHeight = _useState6[1];
  var sheetRef = useRef();
  var closeButtonRef = useRef();
  var actionZoneRef = useRef();
  var refContent = useRef();
  var contentRef = contentContainerRef || refContent;
  var headerContentRef = useRef();
  var isRtl = isDocumentRTL();
  var isDynamicHeight = mobileFixedHeight === 'dynamic' || showGripper;
  var startX;
  var startY;
  var MEDIUM_BREAKPOINT = parseInt(breakpoints.mediaMd, 10);

  /* istanbul ignore next */
  var isMobile = hasWindow() ? ((_window = window) === null || _window === void 0 ? void 0 : _window.innerWidth) < MEDIUM_BREAKPOINT : false;
  var headerLogo = showLogo && !isMobile;
  var idBase = id !== null && id !== void 0 ? id : uniqueId();
  var showHeader = !!action || !noCloseButton || !hideTitle || !!headerContents || headerLogo;

  // jest has no way to test things like scrollTop or scrollHeight --BCC
  /* istanbul ignore next */
  var scrollCheck = function () {
    if (contentRef && contentRef.current) {
      var contents = contentRef.current;
      var newHeaderScroll = contents.scrollTop !== 0;
      if (newHeaderScroll !== headerScroll) {
        setHeaderScroll(newHeaderScroll);
      }

      // Footer is optional, may not be one to watch for!
      if (footerContents) {
        // Have we scrolled to the bottom?
        var newFooterScroll = contents.scrollTop + contents.offsetHeight !== contents.scrollHeight;
        if (newFooterScroll !== footerScroll) {
          setFooterScroll(newFooterScroll);
        }
      }
    }
  };
  /* istanbul ignore next */
  var setFixedHeight = function () {
    var sheetEl = sheetRef.current;
    if (sheetEl) {
      var height90Percent = window.innerHeight * 0.9;
      if (mobileFixedHeight === '100') {
        sheetEl.style.height = "".concat(window.innerHeight);
      } else if (mobileFixedHeight === '90') {
        sheetEl.style.height = "".concat(height90Percent, "px");
      } else if (mobileFixedHeight === '50') {
        sheetEl.style.height = "".concat(window.innerHeight * 0.5, "px");
      } else {
        sheetEl.style.maxHeight = "".concat(height90Percent, "px");
      }
    }
  };

  /* istanbul ignore next */
  var updateHeight = function () {
    var sheetEl = sheetRef.current;
    if (sheetEl) {
      sheetEl.style.height = "".concat(window.innerHeight * dynamicHeight, "px");
      sheetEl.style.maxHeight = 'fit-content';
    }
  };

  /* istanbul ignore next */
  var increaseHeight = function () {
    setDynamicHeight(0.9);
  };

  /* istanbul ignore next */
  var decreaseHeight = function () {
    setDynamicHeight(0.5);
  };

  /* istanbul ignore next */
  var checkContentScroll = function () {
    var content = contentRef && contentRef.current;
    if (dynamicHeight === 0.5) {
      content.style.overflow = 'hidden';
    }
    if (dynamicHeight === 0.9) {
      content.style.overflow = 'scroll';
    }
  };
  useEffect(function () {
    if (!isHidden) {
      var _window2;
      scrollCheck();
      // istanbul ignore next
      // eslint-disable-next-line no-unused-expressions
      (_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.setTimeout(function () {
        // HACK ALERT! react-on-focus fails at setting the focus
        // if we are transitioning opacity. This causes the sheet
        // to set the focus on the close button but NOT indicate
        // that fact to the user either visually or in the screen reader
        // So timeOut was needed

        var focused = false;

        // For combobox input on sheet header
        if (headerContentRef && headerContentRef.current) {
          //@ts-ignore
          var formElement = headerContentRef.current.querySelector('input');
          if (formElement) {
            formElement.focus();
            focused = true;
          }
        }
        // For Forms
        if (!focused && !skipFormFocus && contentRef && contentRef.current) {
          //@ts-ignore
          var focusableEls = contentRef.current.querySelectorAll('a, button, textarea, input, select');
          if (focusableEls.length) {
            focusableEls[0].focus();
            focused = true;
          }
        }
        // Otherwise focus on action item or close button
        if (!focused && showHeader) {
          if (action && actionZoneRef && actionZoneRef.current) {
            //@ts-ignore
            var focusableActionEl = actionZoneRef.current.querySelectorAll('a, button, select');
            if (focusableActionEl.length) {
              focusableActionEl[0].focus();
            }
          } else {
            var closeButtonCurrent = closeButtonRef.current;
            if (closeButtonCurrent) {
              //@ts-ignore
              closeButtonCurrent.focus();
            }
          }
        }
      }, 500);

      /* istanbul ignore next */
      if (isTouchDevice() && window.innerHeight) {
        window.addEventListener('resize', setFixedHeight, false);
        if (isDynamicHeight) {
          updateHeight();
          checkContentScroll();
        } else {
          setFixedHeight();
        }
      }
    }
    return function () {
      window.removeEventListener('resize', setFixedHeight, false);
    };
  }, [isHidden, dynamicHeight]);
  useEffect(function () {
    if (!isHidden && contentRef.current) {
      var contents = contentRef.current;
      contents.scrollTop = contentScrollTop;
    }
  }, [contentScrollTop, isHidden]);
  var wrapperClasses = cx(styles.scrim, !isHidden && styles.scrimShow, showDrawer && styles.justifyRight);
  var containerClasses = cx(modalStyles.base, styles.sheetNoContainer, styles.sheet, mobileFixedHeight === '100' && styles.sheetHeight100, mobileFixedHeight === '90' && styles.sheetHeight90, mobileFixedHeight === '50' && styles.sheetHeight50, isDynamicHeight && styles.sheetHeight50, !isHidden && styles.sheetShow, showDrawer && !isRtl && styles.containerRight, showDrawer && isRtl && styles.containerLeft);
  var contentClasses = cx(modalStyles.modalContents, styles.sheetContent, center && modalStyles.modalContentsCenter, showHeader && styles.sheetContentWithHeader, noPadding && modalStyles.modalContentsNoPadding, showDrawer && styles.drawerContainer);
  var ariaHidden = isHidden ? 'true' : 'false';
  var handleClose = function (evt, closedBy) {
    var okToClose = onBeforeClose(closedBy);
    if (okToClose) {
      requestClose(evt, closedBy);
      startX = null;
      startY = null;
    }
  };
  var closeButtonTag = noCloseButton ? null : /*#__PURE__*/React.createElement(IconButton, _extends({
    svgIconComponent: CloseIcon,
    onClick: function onClick(evt) {
      handleClose(evt, 'closeButton');
    },
    ref: closeButtonRef,
    buttonType: "tertiary"
  }, closeButtonProps, {
    "data-ppui": "true"
  }), closeButtonLabel);
  /* istanbul ignore next */
  var mobileTouchEnd = function (evt, content) {
    var endTouch = evt.changedTouches[0];
    var endX = endTouch.pageX;
    var endY = endTouch.pageY;
    var xDiff = startX - endX;
    var yDiff = startY - endY;

    // means up/down is most significant
    if (Math.abs(yDiff) > Math.abs(xDiff)) {
      // swipe Down
      if (yDiff < 0 && (content ? content.scrollTop === 0 : true)) {
        if (isDynamicHeight) {
          decreaseHeight();
          if (yDiff < -150 || dynamicHeight === 0.5) {
            handleClose(evt, 'swipeDown');
          }
        } else {
          handleClose(evt, 'swipeDown');
        }
      }
      // swipe Up
      if (yDiff > 0 && isDynamicHeight) {
        increaseHeight();
      }
    }
    startX = null;
    startY = null;
  };

  /* istanbul ignore next */
  var handleTouchMove = function (evt) {
    // Prevent from scrolling
    evt.preventDefault();
  };

  /* istanbul ignore next */
  var handleTouchStart = function (evt) {
    /* istanbul ignore next */
    if (!startY && !startX) {
      var firstTouch = evt.changedTouches[0];
      startY = firstTouch.pageY;
      startX = firstTouch.pageX;
    }
  };

  /* istanbul ignore next */

  /* istanbul ignore next */

  var titleId = "header_".concat(idBase);
  var ariaProps = {
    role: 'dialog',
    className: wrapperClassName,
    'aria-modal': 'true',
    'aria-hidden': ariaHidden
  };
  if (headerLogo || hideTitle) {
    ariaProps['aria-label'] = title;
  } else {
    ariaProps['aria-labelledby'] = titleId;
  }

  // If there's a close button, we need to have an action zone even if there's nothing in it
  // Same for close button. Need to have an empty div if there's something in the action
  // But if neither is present, we want to give the whole space to the title.
  var emptyCloseButtonZone = action ? /*#__PURE__*/React.createElement("div", {
    className: modalStyles.modalHeaderClose,
    "data-ppui": "true"
  }) : null;
  var emptyActionZone = closeButtonTag ? /*#__PURE__*/React.createElement("div", {
    className: modalStyles.modalHeaderAction,
    "data-ppui": "true"
  }) : null;

  // Now that we've decided what the empty states would look like, decide if they're actually empty or not
  var closeButtonZone = closeButtonTag ? /*#__PURE__*/React.createElement("div", {
    className: modalStyles.modalHeaderClose,
    "data-ppui": "true"
  }, closeButtonTag) : emptyCloseButtonZone;
  var actionZone = action ? /*#__PURE__*/React.createElement("div", {
    className: modalStyles.modalHeaderAction,
    ref: actionZoneRef,
    "data-ppui": "true"
  }, action) : emptyActionZone;
  var titleContentClasses = headerLogo ? modalStyles.modalHeaderLogo : modalStyles.modalHeaderTitle;
  var titleContentZone = /*#__PURE__*/React.createElement("div", {
    className: titleContentClasses,
    id: titleId,
    "aria-live": "assertive",
    "data-ppui": "true"
  }, function titleContents() {
    if (headerLogo) {
      return /*#__PURE__*/React.createElement("img", {
        src: "https://www.paypalobjects.com/paypal-ui/logos/svg/paypal-mark-color.svg",
        alt: "paypal-logo",
        className: modalStyles.modalHeaderLogoImage,
        "data-ppui": "true"
      });
    }
    return hideTitle ? null : title;
  }());
  var headerContentZone = headerContents ? /*#__PURE__*/React.createElement("div", {
    className: styles.sheetHeaderWorkArea,
    ref: headerContentRef,
    "data-ppui": "true"
  }, headerContents) : null;
  var header = showHeader ? /*#__PURE__*/React.createElement("header", {
    className: cx(modalStyles.modalHeader, styles.sheetHeader, actionZone && styles.sheetHeaderAction, showGripper && styles.showGripper, headerClassName),
    onTouchStart: handleTouchStart,
    onTouchMove: handleTouchMove,
    onTouchEnd: function handleTouchEnd(evt) {
      mobileTouchEnd(evt, null);
    },
    "data-ppui": "true"
  }, actionZone, titleContentZone, closeButtonZone, headerContentZone) : null;
  var footer = footerContents ? /*#__PURE__*/React.createElement("footer", {
    className: cx(modalStyles.modalFooter, footerScroll && modalStyles.modalFooterScrolled, footerAlign === 'center' && modalStyles.modalFooterAlignCenter, footerAlign === 'right' && modalStyles.modalFooterAlignRight, footerClassName),
    "data-ppui": "true"
  }, footerContents) : null;
  var themeClassName = (_document$getElements = document.getElementsByClassName('ppui-theme')[0]) === null || _document$getElements === void 0 ? void 0 : _document$getElements.classList[1];
  return /*#__PURE__*/React.createElement("div", _extends({}, ariaProps, {
    className: cx(themeClassName, wrapperClasses),
    "data-ppui-info": "sheet_2.0.7__8.5.0"
  }), /*#__PURE__*/React.createElement(FocusOn, {
    enabled: !isHidden
    // @ts-ignore: onEscapeKey() wants an Event, but the rest of this code wants SyntheticEvent<>
    ,
    onEscapeKey: function handleEscape(evt) {
      evt.preventDefault();
      handleClose(evt, 'ESC');
    },
    onClickOutside: function handleBackdropClick(evt) {
      handleClose(evt, 'backdropClick');
    },
    returnFocus: returnFocusToTrigger,
    className: cx(styles.containerBottom, showDrawer && styles.containerRightWidth),
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement("article", _extends({
    className: cx(containerClasses, containerClassName)
  }, rest, {
    ref: sheetRef,
    "aria-hidden": ariaHidden,
    "data-ppui": "true"
  }), header, /*#__PURE__*/React.createElement("section", {
    className: cx(contentClasses, className),
    onScroll: function handleScroll() {
      /* istanbul ignore else */
      if (contentRef && contentRef.current) {
        var contents = contentRef.current;

        /* istanbul ignore else */
        if (onContentScroll) {
          onContentScroll(contents.scrollTop);
        }
      }
      scrollCheck();
    },
    ref: contentRef,
    onTouchStart: handleTouchStart,
    onTouchMove: handleTouchMove,
    onTouchEnd: function handleContentTouchEnd(evt) {
      var content = contentRef && contentRef.current;
      if (isDynamicHeight) {
        mobileTouchEnd(evt, content);
      }
    },
    "data-ppui": "true"
  }, children), footer)));
};

var _excluded = ["isOpen", "onOpen", "onCloseComplete", "containerRef"];
var Sheet = function (_ref) {
  var isOpen = _ref.isOpen,
    onOpen = _ref.onOpen,
    onCloseComplete = _ref.onCloseComplete,
    containerRef = _ref.containerRef,
    componentProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isMounted = _useState2[0],
    setIsMounted = _useState2[1];
  useEffect(function () {
    setIsMounted(true);
  }, []);
  var contents = /*#__PURE__*/React.createElement(Animator, {
    shouldHide: !isOpen,
    onOpen: onOpen,
    onCloseComplete: onCloseComplete,
    "data-ppui": "true"
  }, function animatee(props) {
    return /*#__PURE__*/React.createElement(SheetComponent, _extends({}, props, componentProps, {
      "data-ppui": "true"
    }));
  });
  var containerElm = containerRef && containerRef.current;

  // Delay createPortal until component is mounted to fix server side rendering
  return isMounted && ReactDOM.createPortal(contents, containerElm || document.body);
};

export { Sheet };
